import { applicationSettings } from '../../settings/application';
import Bror from './bror';
import Jonaxel from './jonaxel';
import Boaxel from './boaxel';
import Aurdal from './aurdal';
import Ivar from './ivar';
import Elvarli from './elvarli';
import productService from '../products';
import articles from '../products/articles';
import { metricToImperial, MM_PER_INCH } from '../../util/measures';
import { translate } from '../L10n';
import { t } from '../../translations';
import { round } from '../../util/round';
import constants from '../../settings/constants';
import { RANGES } from '../../constants';
import React from 'react';
import { Space, TacItem, Thumbnail } from '../../generalTypes';
import { TacModel } from '../../state/tac/tacTypes';
import { IProduct } from '@inter-ikea-kompis/types/lib';
import { NotImplementedError } from '../util';
import {
  ColorCombination,
  Filter,
} from '../../state/productMenu/productMenuTypes';

let thumbnailData: Thumbnail[];

function init(thumbnails: Thumbnail[]) {
  thumbnailData = thumbnails;
}

function getThumbnailData(fileName: string) {
  return thumbnailData.find(thumb => thumb.id === fileName.substring(1));
}

const getDisabledStatus = (
  tac: TacModel,
  product: TacItem,
  space: Space | undefined,
  rebased: TacItem
) => NotImplementedError();

function getTypeText(article: IProduct) {
  let articleWithData;
  if (productService.isOnlyAvailableInMultipack(article.itemId)) {
    const multipackItemId = constants.BULK_ARTICLES[article.itemId].id;
    articleWithData = articles.getArticle(multipackItemId);
  } else {
    articleWithData = article;
  }

  // @ts-ignore According to kompis docs 'IProduct' contains typeName. According to our typescript, it does not..
  return articleWithData.typeName;
}

const getTableDisplayText = (
  article: IProduct,
  product: TacItem,
  useMetricMeasures: boolean,
  dimension: string
) => '';

const shouldDisplayProductType = (product: TacItem) => NotImplementedError();

function getTrashcanZoomLevel() {
  return 1.16;
}

function displayColor(
  product: TacItem,
  filter: Filter,
  currentColorFilter: ColorCombination
) {
  const noColorItems = filter.designTextBlacklist || [];
  if (noColorItems.includes(product.id)) {
    return false;
  }
  const ids = filter.products.flat();
  const swaps = productService.getSwappables(product, {
    width: product.filter.width,
    depth: product.filter.depth,
    height: product.filter.height,
  });
  return swaps
    .filter(
      swap =>
        ((!currentColorFilter && filter.colors) ||
          (filter.colors &&
            currentColorFilter.colors?.some(
              color => color === swap.filter.color
            ))) &&
        swap.filter.color !== product.filter.color
    )
    .map(swap => swap.id)
    .filter(id => id !== product.id)
    .filter(id => !noColorItems.includes(id))
    .some(id => ids.indexOf(id) !== -1);
}

function getWallMeasurementText(value: number, useMetricMeasures: boolean) {
  const imp = metricToImperial(round(value, MM_PER_INCH));
  return useMetricMeasures
    ? `${value / 10} ${translate(t.MEASURE_VALUE_CM)}`
    : `${imp.feet} ${translate(t.MEASURE_VALUE_FEET)} ${imp.inches} ${translate(
        t.MEASURE_VALUE_IN
      )}`;
}

export type SwiperConfigSectionItem = {
  Component: React.FunctionComponent;
  appliesToFilter: string;
  condition: () => boolean;
};

const getSceneInitFunctions = () => [];
const getSwiperConfigSectionItems = (): SwiperConfigSectionItem[] => [];
const getSwiperFilterText = () => null;

const base = {
  init,
  getDisabledStatus,
  getTypeText,
  getTableDisplayText,
  displayColor,
  shouldDisplayProductType,
  getTrashcanZoomLevel,
  getWallMeasurementText,
  getThumbnailData,
  getSceneInitFunctions,
  getSwiperConfigSectionItems,
  getSwiperFilterText,
};

export const getRange = () => {
  switch (applicationSettings.applicationName) {
    case RANGES.BROR:
      return Bror;
    case RANGES.JONAXEL:
      return Jonaxel;
    case RANGES.BOAXEL:
      return Boaxel;
    case RANGES.AURDAL:
      return Aurdal;
    case RANGES.IVAR:
      return Ivar;
    case RANGES.ELVARLI:
      return Elvarli;
    default:
      console.error('Missing range-specific implementation of swiper service');
      return base;
  }
};

const api = {
  ...base,
  ...getRange(),
};

export default api;
